import { fetchAllTriggers } from 'components/domain/automation/triggers/triggersQuery';
import FilterFormContextSearchField from 'components/filters/FilterFormContextSearchField';
import { SearchOption } from 'components/filters/FilterFormContextSearchField.styles';
import useFilterFormContext from 'components/filters/useFilterFormContext';
import useAppMutation from 'hooks/useAppMutation';

const TriggerSearchField = () => {
  const { searchFieldRef } = useFilterFormContext();
  const { mutateAsync: searchTriggers } = useAppMutation({
    mutationFn: fetchAllTriggers,
  });

  const searchHandler = async (query: string) => {
    const data = await searchTriggers({ triggerName: query });
    return data.triggers;
  };

  return (
    <FilterFormContextSearchField
      containerClassName="search-field"
      labelKey={(option) => `${option.name ?? ''}`}
      name="triggerSearch"
      instanceRef={searchFieldRef}
      renderMenuItemChildren={(option) => (
        <SearchOption data-testid={`found-trigger-${option.uid}`}>
          {option.name}
        </SearchOption>
      )}
      searchHandler={searchHandler}
    />
  );
};

export default TriggerSearchField;
